
<template>
    <div>

		<div class="app-title">
			<div>
				<h1>{{ $t("app.adm.title") }}</h1>
			</div>
		</div>

        <section class="app-content">
            <div class="card-columns">
                <div class="card">
                    <h3 class="card-header text-center"><span class=" text-primary">{{$t('tlt.settings')}}</span></h3>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                        <router-link to="/adm/userPreferences" class="menu-title text-center"><span>{{$t('lbl.preferences.user')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/adm/systemParameters" class="menu-title text-center"><span>{{$t('tlt.systemParameters')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/adm/threadHistory" class="menu-title text-center"><span>{{$t('tlt.threadHistory')}}</span></router-link></li>                        
                    </ul>
                </div>
                <div class="card">
                    <h3 class="card-header text-center"><span class=" text-primary">{{$t('tlt.messages')}}</span></h3>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                        <router-link to="/adm/integrationMessage" class="menu-title text-center"><span>{{$t('tlt.messageTracking')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/adm/integrationMessageConfig" class="menu-title text-center"><span>{{$t('tlt.messageConfig')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/adm/integrationMessageTest" class="menu-title text-center"><span>Message Test</span></router-link></li>
                    </ul>
                </div>
            </div>
        </section>
    </div>    
</template>

<script>
export default {
  name: "home"
};
</script>
